export const getAnnoucementCount = (payload?: any) => ({
  type: "@saga/GET_ANNOUCEMENT_COUNT",
  payload,
});
